import { render, staticRenderFns } from "./AddProductReport.vue?vue&type=template&id=5c80f698&scoped=true"
import script from "./AddProductReport.vue?vue&type=script&lang=js"
export * from "./AddProductReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c80f698",
  null
  
)

export default component.exports